import React from 'react';

import ViewportMgr from 'coreClasses/view/ViewportMgr';

const breakpointsList = ViewportMgr.getBreakpoints();
export type TBreakpointsList = typeof breakpointsList[number];

export enum EGridSpacing {
	'None' = 'none',
	'Extra Small' = 'xs',
	'Small' = 'sm',
	'Medium' = 'md',
	'Large' = 'lg',
	'Extra Large' = 'xl',
}

export interface IGridContentfulProps {
	children: React.ReactNode;
	isFluid?: boolean;
	verticalGutters?: EGridSpacing;
	sys?: {id: string};
	itemsCollection?: {items: []};
}

export type ISpacingFields = {
	[key in TBreakpointsList]: {
		top?: string;
		right?: string;
		bottom?: string;
		left?: string;
	};
};

export type ISkeletonFields = {
	[key in TBreakpointsList]: {
		height?: string;
	};
};

export type IAlignmentFields = {
	[key in TBreakpointsList]: {
		cross?: string;
		main?: string;
	};
};
